import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Subscription } from 'rxjs';
import { FacilityExportHistoryComponent } from './facility-export-history/facility-export-history.component';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { FacilityExportService } from '../services/facility-export.service';

@Component({
  selector: 'app-facility-export',
  templateUrl: './facility-export.component.html',
  styleUrl: './facility-export.component.css'
})
export class FacilityExportComponent implements OnInit, OnDestroy {
  public hospid: number = 0;
  private loading = false;
  private $subscriptions: Subscription = new Subscription();
  private $navigationSubscription: Subscription;
  isInitialized = false;
  
  @ViewChild(FacilityExportHistoryComponent) history: FacilityExportHistoryComponent;

  public isDataLoading() {
    return this.history ? this.history.loading : false;
  }
  
  constructor(
      private router: Router,
      private route: ActivatedRoute,
      private dataService: FacilityExportService) {
      this.$navigationSubscription = this.router.events
        .subscribe((e: any) => {
          if (e instanceof NavigationEnd) {
            this.handleNavigationEvent();
          }
        });
    }

  ngAfterViewInit() {
    console.log('Facility Export History component:', this.history);
  }
  ngOnInit(): void {
  }

  onExportRequest($requested) {
    this.history.refreshHistory();
  }

  
  private handleNavigationEvent() {
    this.updateFacilityIdentifier();
  }

  private updateFacilityIdentifier() {
    if (this.route.snapshot.queryParams) {
      const _hospId = this.route.snapshot.queryParams.hospid;
      if (_hospId) {
        this.hospid = Number(_hospId);
        this.isInitialized = true;
      }
    }
  }

  // public isDataLoading() {
  //   return this.loading;
  // }   
  
  private Unsubscribe() {
    if (this.$subscriptions) {
      this.$subscriptions.unsubscribe();
    }
    if (this.$navigationSubscription) {
      this.$navigationSubscription.unsubscribe();
    }
  }

  ngOnDestroy(): void {
    this.Unsubscribe();
  }
}
